// renewPendingChatMessage.js
'use strict';
import getListData from '../selector/getListData.js';
import { ADD_LIST_ITEMS, REMOVE_LIST_ITEMS } from '../ActionTypes.js';

/**
 * Renew chat message
 * @kind action
 * @param {string} {sentMessageId} - sent message id.
 * @param {obj} {message} - pending message.
 * @param {string} {chatroomId} - chatroom id
 * @return {Promise} Action promise.
 */
const renewPendingChatMessage =
  ({ sentMessageId, message, chatroomId }) =>
  async (dispatch, getState) => {
    const pendingListPath = ['chatroom', chatroomId, 'pendingMessages'];
    const listSelectPath = ['chatroom', chatroomId, 'messages'];
    const nextPage = getListData(getState(), listSelectPath, 'nextPage');
    const lastPage = getListData(getState(), listSelectPath, 'lastPage');
    const totalCount = getListData(getState(), listSelectPath, 'totalCount');

    dispatch({
      type: ADD_LIST_ITEMS,
      payload: {
        selectPath: listSelectPath,
        itemIds: [sentMessageId],
        nextPage,
        lastPage,
        totalCount: totalCount + 1,
      },
    });
    return dispatch({
      type: REMOVE_LIST_ITEMS,
      payload: { selectPath: pendingListPath, itemIds: [message.id] },
    });
  };

export default renewPendingChatMessage;
